module.exports = __webpack_public_path__ + "img/icon--settings--white.6c1c5e68.svg";